"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
const EBlockchainName_1 = __importDefault(require("./EBlockchainName"));
const EAnchoringStatus_1 = __importDefault(require("./EAnchoringStatus"));
const OfficeFolder_1 = __importDefault(require("./OfficeFolder"));
const class_validator_1 = require("class-validator");
class OfficeFolderAnchor extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.blockchain = EBlockchainName_1.default.TEZOS;
        this.status = EAnchoringStatus_1.default.QUEUED;
        this.anchor_nb_try = 0;
        this.tx_id = null;
        this.tx_link = null;
        this.tx_hash = null;
        this.anchor_job_id = null;
        this.folder = null;
        this.anchored_at = null;
        this.created_at = null;
        this.updated_at = null;
    }
}
exports.default = OfficeFolderAnchor;
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeFolderAnchor.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Array)
], OfficeFolderAnchor.prototype, "hash_sources", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeFolderAnchor.prototype, "root_hash", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeFolderAnchor.prototype, "blockchain", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], OfficeFolderAnchor.prototype, "status", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Number)
], OfficeFolderAnchor.prototype, "anchor_nb_try", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], OfficeFolderAnchor.prototype, "tx_id", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], OfficeFolderAnchor.prototype, "tx_link", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], OfficeFolderAnchor.prototype, "tx_hash", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], OfficeFolderAnchor.prototype, "anchor_job_id", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => OfficeFolder_1.default),
    __metadata("design:type", Object)
], OfficeFolderAnchor.prototype, "folder", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], OfficeFolderAnchor.prototype, "anchored_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], OfficeFolderAnchor.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], OfficeFolderAnchor.prototype, "updated_at", void 0);
